type Localisation = {
  formatTime(date: Date): string;
};

export const formatTimeBucketRange = (
  start: Date,
  end: Date,
  localisation: Localisation,
): string =>
  `${localisation.formatTime(start)} - ${localisation.formatTime(end)}`;
